import * as R from 'ramda'

import { categoryNames } from 'components/common/JobProfileWidget/text'
import { getLanguages } from 'utils/languages'

const getPickedCompetencies = competencies =>
  R.pipe(
    R.toPairs,
    R.filter(([name, value]) => R.and(R.equals(value, R.T()), name)),
    R.map(([name]) => name),
  )(competencies)

const getLabels = R.pipe(
  R.toPairs,
  R.map(([name, [label]]) => ({ label, name })),
)

export const getLanguageLabels = languages => {
  const labels = getLanguages()

  return R.pipe(
    R.filter(({ label, value }) => R.and(R.includes(value, languages), label)),
    R.map(({ label }) => label),
    R.join(', '),
  )(labels)
}

export const getCompetenciesLabels = (competencies, language) => {
  const names = getPickedCompetencies(competencies)
  const labels = getLabels(categoryNames(language))

  const selectedLabels = R.pipe(
    R.filter(({ name }) => R.includes(name, names)),
    R.map(({ label }) => label),
  )(labels)

  return selectedLabels.map((label, idx) =>
    idx < selectedLabels.length - 1 ? `${label},` : label,
  )
}
